import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { challengeAPI } from '../../services/api';
import { Challenge } from '../../types';
import { ChallengeView } from './ChallengeView';

export const ChallengeDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [challenge, setChallenge] = useState<Challenge | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Fetch challenge details
  useEffect(() => {
    if (id) {
      challengeAPI.getChallenge(Number(id))
        .then(setChallenge)
        .catch(() => setError('Failed to load challenge.'))
        .finally(() => setLoading(false));
    }
  }, [id]);

  if (loading) return <div className="text-center text-gray-300 py-12">Loading...</div>;
  if (error) return <div className="text-center text-red-400 py-12">{error}</div>;
  if (!challenge) return <div className="text-center text-gray-300 py-12">Challenge not found.</div>;

  return (
    <ChallengeView challenge={challenge} onBack={() => window.history.back()} />
  );
}; 